import {createContext} from 'react';

export const PokeContext = createContext({}); // Hold core data of the poke
export const PokeStateContext = createContext({}); // Hold state data of the poke when displayed
